(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["po-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  var lb = document.getElementById('po-prod-lightbox');
  if (!lb) return;
  var img = lb.querySelector('.po-prod__lightbox-img');
  var lastFocus = null;

  function open(src, alt) {
    img.src = src;
    img.alt = alt || '';
    lb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    lastFocus = document.activeElement;
    var btn = lb.querySelector('.po-prod__lightbox-close');
    if (btn) btn.focus();
  }
  function close() {
    lb.classList.remove('is-open');
    document.body.style.overflow = '';
    img.src = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  var links = document.querySelectorAll('.po-prod__zoom');
  for (var i = 0; i < links.length; i++) {
    links[i].addEventListener('click', function (e) {
      e.preventDefault();
      open(this.getAttribute('href'), this.getAttribute('data-alt'));
    });
  }
  lb.addEventListener('click', function (e) {
    if (e.target === lb || e.target.hasAttribute('data-close')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && lb.classList.contains('is-open')) close();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["po-sticky"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.getElementById('po-sticky');
  if (!bar) return;

  var startTarget = document.querySelector('.po-test');
  // The page inherits the store footer; hide the bar over it (fall back to .po-footer
  // for any theme that still renders our own footer section).
  var endTarget = document.querySelector('.shopify-section-group-group-footer')
               || document.querySelector('.site-footer, #SiteFooter')
               || document.querySelector('.po-footer');
  var armed = false, dismissed = false, atEnd = false;

  function update() {
    if (armed && !dismissed && !atEnd) { bar.hidden = false; bar.classList.add('is-visible'); }
    else { bar.classList.remove('is-visible'); bar.hidden = true; }
  }

  if ('IntersectionObserver' in window) {
    if (startTarget) {
      var ioStart = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting || entries[i].boundingClientRect.top <= 0) {
            armed = true; update(); ioStart.disconnect(); break;
          }
        }
      }, { threshold: 0 });
      ioStart.observe(startTarget);
    }
    if (endTarget) {
      var ioEnd = new IntersectionObserver(function (entries) {
        atEnd = entries[entries.length - 1].isIntersecting;
        update();
      }, { threshold: 0 });
      ioEnd.observe(endTarget);
    }
  }

  var close = bar.querySelector('.po-sticky__close');
  if (close) close.addEventListener('click', function () {
    dismissed = true; update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["po2-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  var lb = document.getElementById('po-prod-lightbox');
  if (!lb) return;
  var img = lb.querySelector('.po-prod__lightbox-img');
  var lastFocus = null;

  function open(src, alt) {
    img.src = src;
    img.alt = alt || '';
    lb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    lastFocus = document.activeElement;
    var btn = lb.querySelector('.po-prod__lightbox-close');
    if (btn) btn.focus();
  }
  function close() {
    lb.classList.remove('is-open');
    document.body.style.overflow = '';
    img.src = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  var links = document.querySelectorAll('.po-prod__zoom');
  for (var i = 0; i < links.length; i++) {
    links[i].addEventListener('click', function (e) {
      e.preventDefault();
      open(this.getAttribute('href'), this.getAttribute('data-alt'));
    });
  }
  lb.addEventListener('click', function (e) {
    if (e.target === lb || e.target.hasAttribute('data-close')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && lb.classList.contains('is-open')) close();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["po2-sticky"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.getElementById('po-sticky');
  if (!bar) return;

  var startTarget = document.querySelector('.po-test');
  // The page inherits the store footer; hide the bar over it (fall back to .po-footer
  // for any theme that still renders our own footer section).
  var endTarget = document.querySelector('.shopify-section-group-group-footer')
               || document.querySelector('.site-footer, #SiteFooter')
               || document.querySelector('.po-footer');
  var armed = false, dismissed = false, atEnd = false;

  function update() {
    if (armed && !dismissed && !atEnd) { bar.hidden = false; bar.classList.add('is-visible'); }
    else { bar.classList.remove('is-visible'); bar.hidden = true; }
  }

  if ('IntersectionObserver' in window) {
    if (startTarget) {
      var ioStart = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting || entries[i].boundingClientRect.top <= 0) {
            armed = true; update(); ioStart.disconnect(); break;
          }
        }
      }, { threshold: 0 });
      ioStart.observe(startTarget);
    }
    if (endTarget) {
      var ioEnd = new IntersectionObserver(function (entries) {
        atEnd = entries[entries.length - 1].isIntersecting;
        update();
      }, { threshold: 0 });
      ioEnd.observe(endTarget);
    }
  }

  var close = bar.querySelector('.po-sticky__close');
  if (close) close.addEventListener('click', function () {
    dismissed = true; update();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
